module.exports = __webpack_public_path__ + "img/cursos.cfd4ef79.svg";